import { z } from 'zod'

import { TriggerRuleSchema } from 'shared/api/common/schemas/flow/triggerRule'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

const TriggerRuleStatusDataSchema = z.object({
  result: TriggerRuleSchema,
  done: z.boolean(),
  progress: z.number(),
})

const TriggerRuleUpdateDataSchema = z.object({
  trigger_rule: TriggerRuleSchema,
  need_activate: z.boolean(),
})

export type TriggerRuleStatusData = z.infer<typeof TriggerRuleStatusDataSchema>
export type TriggerRuleUpdateData = z.infer<typeof TriggerRuleUpdateDataSchema>

export const TriggerRuleSocketSchema = {
  setTriggerRuleStatus: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_status_update_action'),
    status: TriggerRuleStatusDataSchema,
  }),
  update: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_updated'),
    model: TriggerRuleUpdateDataSchema,
  }),
  created: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_created'),
    model: TriggerRuleSchema,
  }),
  copied: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_copied'),
    model: TriggerRuleSchema,
  }),
  titleSet: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_title_set'),
    model: TriggerRuleSchema,
  }),
  deleted: SocketEventBaseSchema.extend({
    event: z.literal('trigger_rule_deleted'),
    model: TriggerRuleSchema,
  }),
}
